import React from 'react';
import styles from './FeedBack.module.scss'
import ContentBox from "../../common/ContentBox/ContentBox";

function FeedBack({variant= 'blueish', title ='No title',  innerHTML}) {
    return <div className={styles.FeedBack} >
        <ContentBox title={title} variant={variant} style={{maxHeight: "250px", overflow: "hidden"}} htmlContent={innerHTML} >

        </ContentBox>
    </div>
}

export default FeedBack;
